export const INSURANCE_AUTO = Object.freeze({
    TYPE_STANDARD: {
        ID: 3,
        NAME: 'Standard'
    },
    TYPE_RESEAU: {
        ID: 4,
        NAME: 'Réseau'
    },
    TYPE_MAXI_RESEAU: {
        ID: 5,
        NAME: 'Maxi Réseau'
    },
    TYPE_MAXI_PLUS: {
        ID: 1,
        NAME: 'Maxi Plus'
    },
    TYPE_PRESTIGE: {
        ID: 2,
        NAME: 'Prestige'
    },
});

export const INSURANCE_GARDEN = Object.freeze({
  TYPE_PANNE: {
    ID: 1,
    NAME: 'Panne Mécanique'
  },
  TYPE_CASSE: {
    ID: 2,
    NAME: 'Casse'
  },
  TYPE_PC: {
    ID: 3,
    NAME: 'Panne Mécanique + Casse'
  },
});

export const AUTO_ENGINE = Object.freeze({
    ESSENCE: {
        ID: 1,
        NAME: 'Essence',
    },
    DIESEL: {
        ID: 2,
        NAME: 'Diesel',
    },
    GPL: {
        ID: 3,
        NAME: 'GPL',
    },
    ELECTRIC: {
        ID: 4,
        NAME: 'Electrique',
    },
    HYBRIDE: {
        ID: 5,
        NAME: 'Hybride',
    }
});

export const AUTO_TYPE = Object.freeze({
    VP: {
        ID: 1,
        NAME: 'V.P',

    },
    VU: {
        ID: 2,
        NAME: 'V.U',

    },
    '4X4': {
        ID: 3,
        NAME: '4X4',

    },
});

export const GARDENTOOL_TYPE = Object.freeze({
  TONDEUSE: {
    ID: 1,
    NAME: 'Tondeuse, Robot',

  },
  TRONCONNEUSE: {
    ID: 2,
    NAME: 'Tronçonneuse',

  },
  TAILLEHAIE: {
    ID: 3,
    NAME: 'Taille-Haie',

  },
  DEBROUSAILLEUSE: {
    ID: 4,
    NAME: 'Débrousailleuse',

  },
  ELAGUEUSE: {
    ID: 5,
    NAME: 'Elagueuse',

  },
  AUTRES: {
    ID: 6,
    NAME: 'Autres',

  },
});

export const AUTO_DURATION = Object.freeze({
    MONTH_3: {
        ID: 1,
        NAME: '3 Mois',
    },
    MONTH_6: {
        ID: 2,
        NAME: '6 Mois',
    },
    MONTH_12: {
        ID: 3,
        NAME: '12 Mois',
    },
    MONTH_24: {
        ID: 4,
        NAME: '24 Mois',
    },
});

export const AUTO_POWER_KW = Object.freeze({
    MINUS_150: {
        ID: 1,
        NAME: '- de 150 Kw',
    },
    FROM_150_TO_400: {
        ID: 2,
        NAME: 'De 150 Kw à 400 Kw',
    },
    PLUS_400: {
        ID: 3,
        NAME: '+ de 400 Kw',
    }
});



// WEBPACK FOOTER //
// ./src/constants/insuranceAuto.js